// extracted by mini-css-extract-plugin
export default {"form_input":"style_form_input__UoSlU"};